// ============================================
// FILE: src/components/PrivacyPolicyScreen.jsx
// ============================================

import { ArrowLeft } from 'lucide-react';

const PrivacyPolicyScreen = ({ onBack = null, setActiveTab, appTheme = 'blue', isDesktop = false }) => {
  const goHome = () => setActiveTab && setActiveTab('home');

  // Header style
  const headerStyle = appTheme === 'white'
    ? { background: '#fff', color: '#222', boxShadow: '0 2px 16px 0 rgba(0,0,0,0.04)' }
    : { background: 'var(--header-gradient)', color: 'var(--text-light)' };

  return (
    <div className="pb-20 min-h-screen" style={{ background: 'var(--primary-bg)', color: 'var(--text-main)' }}>
      {/* ─── HEADER ─── */}
      <div className={`p-6 shadow-lg ${isDesktop ? 'rounded-3xl max-w-3xl mx-auto' : 'rounded-b-3xl'}`} style={headerStyle}>
        <div className="flex items-center gap-3 mb-4">
          <button
            onClick={onBack || goHome}
            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-all"
          >
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-semibold">Privacy Policy</h2>
        </div>
      </div>
      {/* ─── CONTENT ─── */}
      <div className={`p-4 space-y-4 ${isDesktop ? 'max-w-3xl mx-auto' : ''}`}>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">Introduction</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            <div className="font-bold text-gray-800 mb-2">DealStore.app Privacy Policy</div>
            We value your privacy and are committed to protecting your personal information. This policy explains how we collect, use, and safeguard your data.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">
                We i.e. <b>Algolive OPC Private Limited</b>(sponsor the DealStore.app ecomerce platform for cousumer goods products) , are committed to protecting the privacy and security of your personal information. Your privacy is important to us and maintaining your trust is paramount.
           </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">Scope of Policy</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            This privacy policy explains how we collect, use, process and disclose information about you. By using our website/ app/ platform and affiliated services, you consent to the terms of our privacy policy (“Privacy Policy”) in addition to our ‘Terms of Use.’ We encourage you to read this privacy policy to understand the collection, use, and disclosure of your information from time to time, to keep yourself updated with the changes and updates that we make to this policy.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">Information Sharing</h3>
           <p className="text-gray-600 text-sm leading-relaxed">
           This privacy policy describes our privacy practices for all websites, products and services that are linked to it. However this policy does not apply to those affiliates and partners that have their own privacy policy. In such situations, we recommend that you read the privacy policy on the applicable site.
            Should you have any clarifications regarding this privacy policy, please write to us at support@dealstore.app
           </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">1. Information Collection</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            We collect personal information you provide, such as your name, contact details, and address, to deliver our services.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">2. Use of Information</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            Your information is used to process orders, improve our services, and communicate with you about your account or offers.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">3. Data Security</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            We implement security measures to protect your data. However, no method of transmission over the internet is 100% secure.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">4. Sharing of Information</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            We do not sell or rent your personal information. We may share it with trusted partners to fulfill your orders or comply with the law.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">5. Cookies</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            Our app may use cookies to enhance your experience. You can disable cookies in your browser settings if you prefer.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">6. Changes to Policy</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            We may update this privacy policy from time to time. Please review it periodically for changes.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm p-4">
          <h3 className="font-semibold text-gray-800 mb-3">7. Contact Us</h3>
          <p className="text-gray-600 text-sm leading-relaxed">
            If you have any questions about this privacy policy, please contact us at support@dealstore.app.
          </p>
        </div>
        <div className="text-center text-gray-500 text-xs">
         <p>Office No. 719, 83 Metro Street, SVH, Sector 83, Gurgaon, India</p>
        </div>  
        <div className="text-center text-gray-500 text-xs mt-6">
          &copy; {new Date().getFullYear()} Algolive OPC Private Limited. All rights reserved.  
        </div>        
      </div>
    </div>
  );
};

export default PrivacyPolicyScreen;
